// Seeded Data for Clow Cards

const cards = [
    {
      id: 1,
      title: 'the dark',
      category: 'dark',
      guardian: 'Yue - Moon',
      img: 'https://i.imgur.com/yTJgibz.jpeg',
      desc: `The Dark (Kanji: 闇, Katakana: ダーク, Romanji: Dāku) is a Clow Card with the power to control darkness. Alongside The Light, it is one of the foremost of the Clow Cards, and falls under the power of the Moon, Yue and Eastern Magic. `,
    },
    {
      id: 2,
      title: 'the light',
      category: 'light',
      guardian: 'Kero - Sun',
      img: 'https://i.imgur.com/Jut3y6l.jpeg',
      desc: `The Light (Kanji: 光, Katakana: ライト, Romanji: Raito) is a Clow Cards with the power to control light. Alongside The Dark, it is one of the foremost of the Clow Cards, and falls under the power of the Sun, Cerberus, and Western Magic.`,
    },
    {
      id: 3,
      title: 'the watery',
      category: 'water',
      guardian: 'Yue - Moon',
      img: 'https://i.imgur.com/t6xNpAx.jpeg',
      desc: `The Watery (Kanji: 水, Katakana: ウォータリー, Romanji: Uōtarī) is a Clow Card with the power to manipulate and control water. It is one of the four elemental cards, and as such it is one of the most powerful. Watery falls under the power of the Moon, Yue and under Eastern Magic.`,
    },
    {
      id: 4,
      title: 'the firey',
      category: 'fire',
      guardian: 'Kero - Sun',
      img: 'https://i.imgur.com/uwTRmqf.jpeg',
      desc: `The Firey (Kanji: 火, Katakana: ファイーリー, Romanji: Faīrī) is a Clow Card with the power to control and manipulate fire. It is one of the four elemental cards, and as such it is one of the most powerful. Firey falls under the power of the Sun, Cerberus and Western Magic`,
    },
    {
      id: 5,
      title: 'the windy',
      category: 'wind',
      guardian: 'Yue - Moon',
      img: 'https://i.imgur.com/3xZabqi.jpeg',
      desc: `The Windy (Kanji: 風, Katakana: ウィンディー, Romanji: Uuindī) is a Clow Card with the power to create and control wind. It is one of the four elemental cards, and as such it is one of the most powerful. Windy falls under the power of the Moon, Yue and under Eastern Magic.`,
    },
    {
      id: 6,
      title: 'the earthy',
      category: 'earth',
      guardian: 'Kero - Sun',
      img: 'https://i.imgur.com/T7DqR79.jpeg',
      desc: `The Earthy (Kanji: 地, Katakana: アーシー, Romanji: Āshī) is a Clow Card with the power to control and manipulate earth. It is one of the four elemental cards, and as such it is one of the most powerful. Earthy falls under the power of the Sun, Cerberus and under Western Magic.`,
    },
    {
      id: 7,
      title: 'the change',
      category: 'dark',
      guardian: 'Yue - Moon',
      img: 'https://i.imgur.com/xNONQYi.jpeg',
      desc: `The Change (Kanji: 替, Katakana: チェーンジ, Romanji: Chēnji) is a Clow Card with the power to cause two people to switch bodies. It is under The Dark and under the power of the moon, Yue, and Eastern magic.`,
    },
      {
        id: 8,
        title: 'the illusion',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/3Z9BWlM.jpeg',
        desc: `The Illusion (Kanji: 幻, Katakana: イルージョン, Romanji: Irūjon) is a Clow Card with the power to create illusions. It is under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 9,
        title: 'the dream',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/x1RY7Rf.jpeg',
        desc: `The Dream (Kanji: 夢, Katakana: ドリーム, Romanji: Dorīmu) is a Clow Card with the power to manipulate dreams. It is under The Dark, the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 10,
        title: 'the erase',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/HAoJzMR.jpeg',
        desc: `The Erase (Kanji: 消, Katakana: エレーズ, Romanji: Erēzu) is a Clow Card with the power to erase anything from existence. It is under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 11,
        title: 'the silent',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/Ax9aGJP.jpeg',
        desc: `The Silent (Kanji: 静, Katakana: サイレント, Romanji: Sairento) is a Clow Card with the power to manipulate silence. It is aligned under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 12,
        title: 'the sleep',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/WgeE9VX.jpeg',
        desc: `The Sleep (Kanji: 眠, Katakana: スリープ, Romanji: Surīpu) is a Clow Card with the power to put anyone to sleep. It is aligned under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 13,
        title: 'the time',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/P5Ji1Au.jpeg',
        desc: `The Time (Kanji: 時, Katakana: タイム, Romanji: Taimu) is a Clow Card with the power to manipulate time. It is aligned under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
      {
        id: 14,
        title: 'the big',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/0XYeRIM.jpg',
        desc: `The Big (Kanji: 大, Katakana: ビグ, Romanji: Bigu) is a Clow Card with the power to grow creatures and objects in size. It is aligned under The Light card and under the power of the Sun, Cerberus, and Western Magic, as is its opposing card, The Little.`,
      },
      {
        id: 15,
        title: 'the create',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/M8Iinp9.jpg',
        desc: `The Create (Kanji: 創, Katakana: クリエイト, Romanji: Kurīēto) is a Clow Card with the power to bring creatures or objects into existence. It is aligned under The Light and under the power of the Sun, Cerberus, and Western Magic.`,
      },
      {
        id: 16,
        title: 'the glow',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/pl8xpkj.jpg',
        desc: `The Glow (Kanji: 灯, Katakana: グロー, Romanji: Gurō) is a Clow Card with the power to create tiny glowing lights. It is aligned under The Light and under the power of the Sun, Cerberus, and Western Magic.`,
      },
      {
        id: 17,
        title: 'the little',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/OvAUIoU.jpg',
        desc: `The Little (Kanji: 小, Katakana: リタル, Romanji: Ritaru) is a Clow Card with the power to shrink creatures and objects to miniature size. It is aligned under The Light and under the power of the Sun, Cerberus, and Western Magic.`,
      },
      {
        id: 18,
        title: 'the return',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/7ytuUyA.jpg',
        desc: `The Return (Kanji: 戻, Katakana: レターン, Romanji: Retān) is one of the fifty-three Clow Cards in the anime. It is under The Light and under the power of the Sun, Cerberus, and Western Magic.`,
      },
      {
        id: 19,
        title: 'the shadow',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/dDVqMAm.jpeg',
        desc: `The Shadow (Kanji: 影, Katakana: シャッドー, Romanji: Shaddō) is a Clow Card with the power to control and manipulate shadows. It is under The Light and under the power of the Sun, Cerberus, and Western Magic.`,
      },
      {
        id: 20,
        title: 'the sweet',
        category: 'light',
        guardian: 'Kero - Sun',
        img: 'https://i.imgur.com/WgeE9VX.jpeg',
        desc: `The Sweet (Kanji: 甘, Katakana: スウィート, Romanji: Suuīto) is one of the fifty-two Clow Cards in the anime.`,
      },
      {
        id: 21,
        title: 'the bubbles',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/rDqVuMe.jpeg',
        desc: `The Bubbles (Kanji: 泡, Katakana: バブル, Romanji: Baburu)  is one of the fifty-two Clow Cards in the anime.`,
      },
      {
        id: 22,
        title: 'the cloud',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/zp9Lc2s.jpeg',
        desc: `The Cloud (Kanji: 雲, Katakana: クラウド, Romanji: Kuraudo) is one of the fifty-two Clow Cards in the anime.`,
      },
      {
        id: 23,
        title: 'the freeze',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/u9Dmccz.jpeg',
        desc: `The Freeze (Kanji: 凍, Katakana: フリーズ, Romanji: Furīzu) is one of the fifty-two Clow Cards in the anime. It is aligned under the Watery card. Its Clear Card counterpart is "Hail" just like the Snow.`,
      },
      {
        id: 24,
        title: 'the mist',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/wLV6GG2.jpeg',
        desc: `The Mist (Kanji: 霧, Katakana: ミスト, Romanji: Misuto)  is one of the fifty-two Clow Cards in the anime.`,
      },
      {
        id: 27,
        title: 'the rain',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/Rc6EX4S.jpeg',
        desc: `The Rain (Kanji: 雨, Katakana: レーン, Romanji: Rēn) is one of the fifty-two Clow Cards in the anime.`,
      },
      {
        id: 28,
        title: 'the snow',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/qoaIDDG.jpeg',
        desc: `The Snow (Kanji: 雪, Katakana: スノー, Romanji: Sunō) is a Clow Card with the power to create and control snow. It is aligned under the Watery and under the power of the Moon, Yue, and eastern magic.`,
      },
      {
        id: 29,
        title: 'the wave',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/wDPKGvw.jpeg',
        desc: `The Wave (Kanji: 波, Katakana: ウェーブ, Romanji: Uēbu) capture is never seen in the anime, but from its name, it has been surmised that it is a less-powerful version of Watery, probably able to control existing water near it, but unable to create new water magically like Watery can, capable of creating gigantic tidal waves.`,
      },
      {
        id: 30,
        title: 'the wood',
        category: 'dark',
        guardian: 'Yue - Moon',
        img: 'https://i.imgur.com/z7tSPLq.jpeg',
        desc: `The Time (Kanji: 時, Katakana: タイム, Romanji: Taimu) is a Clow Card with the power to manipulate time. It is aligned under The Dark and under the power of the Moon, Yue, and Eastern Magic.`,
      },
  ];

  export default cards;